import React from 'react';

export default function DoctorCard({ nombre, especialidad, bio, foto }) {
  return (
    <div className="text-center group">
      <div className="w-36 h-36 mx-auto rounded-full overflow-hidden bg-teal-100 mb-5 border-4 border-white shadow-md">
        {foto
          ? <img src={foto} alt={nombre} className="w-full h-full object-cover" />
          : <div className="w-full h-full flex items-center justify-center text-teal-600 font-display text-4xl">
              {nombre.charAt(0)}
            </div>
        }
      </div>
      <h3 className="font-display text-xl text-stone-800">{nombre}</h3>
      <p className="text-teal-600 text-sm mt-1 mb-3">{especialidad}</p>
      <p className="text-stone-500 text-sm leading-relaxed max-w-xs mx-auto">{bio}</p>
    </div>
  );
}